import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Grid } from "@elliemae/ds-grid";
import { useState } from "react";
import { DSAccordion, DSAccordionItem } from "@elliemae/ds-accordion";
import { DSHeader } from "@elliemae/ds-header";
import { DSSeparator } from "@elliemae/ds-separator";
import {
  Controller,
  FormProvider,
  useForm
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { Textbox } from "./controls/textbox";
import { Combobox } from "./controls/combobox";
import { Checkbox } from "./controls/checkbox";
import { Date } from "./controls/date";
import {
  SchemaAndRulesDto
} from "../../models/workspaceValidatableTypes";
const SchemaSearchForm = ({ preview, schema }) => {
  const selectLoanData = () => ({ EPPS = { loanInfo: {} } }) => EPPS.loanInfo || {};
  const useLoanInformationSelector = () => useSelector(selectLoanData());
  const loanInfo = useLoanInformationSelector() || {};
  const screens = schema.schema.screens[0].screens;
  const sections = schema.schema.screens;
  const schemaForm = useForm({
    mode: "onChange",
    resolver: yupResolver(SchemaAndRulesDto),
    ...preview ? {} : { defaultValues: loanInfo },
    resetOptions: { keepValues: false }
  });
  const [activeAccordions, setActiveAccordions] = useState({});
  const handleAccordionToggle = (value) => {
    setActiveAccordions((prev) => ({
      ...prev,
      [value]: !prev[value]
    }));
  };
  const fieldComponentMap = {
    text: Textbox,
    currency: Textbox,
    percent: Textbox,
    enum: Combobox,
    boolean: Checkbox,
    datepicker: Date
  };
  const renderField = (field) => {
    if (!field.visible) return null;
    const {
      type,
      ui,
      componentId,
      label,
      required,
      modelPath,
      helptext,
      options,
      selectMultiple,
      disabled
    } = field;
    const key = type === "string" && ui.widget === "text" ? "text" : type === "number" && (ui.widget === "currency" || ui.widget === "percent") ? "currency" : type === "enum" ? "enum" : type === "boolean" ? "boolean" : type === "string" && ui.widget === "datepicker" ? "datepicker" : null;
    const Component = key ? fieldComponentMap[key] : null;
    if (!Component) return null;
    return /* @__PURE__ */ jsx(
      Controller,
      {
        name: modelPath,
        render: ({ field: renderedField }) => /* @__PURE__ */ jsx(
          Component,
          {
            renderedField,
            schemaForm,
            name: componentId,
            label,
            required,
            pathValue: modelPath,
            feedbackMessage: helptext,
            ui,
            options,
            isMulti: selectMultiple,
            disabled
          }
        )
      }
    );
  };
  const renderScreenFields = (screenId, sectionName) => {
    const section = sections.find((section2) => section2.id === screenId);
    const fields = section.fields?.find(
      (fieldTypes) => fieldTypes.name === sectionName
    )?.fields || [];
    return fields.map((field) => renderField(field));
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(FormProvider, { ...schemaForm, children: screens?.map((screen, index) => /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(
      DSHeader,
      {
        text: sections.find((section) => section.id === screen.id)?.name,
        fontSize: 16,
        fontWeight: "bold",
        lineHeight: 1,
        mt: "xs",
        mb: "xxs",
        color: void 0,
        fontFamily: void 0,
        height: void 0,
        level: void 0,
        width: void 0
      }
    ),
    /* @__PURE__ */ jsx(Grid, { cols: 12, gutter: "xs", alignItems: "flex-start", children: renderScreenFields(screen.id, "VISIBLE") }),
    /* @__PURE__ */ jsx(Grid, { span: 12, children: /* @__PURE__ */ jsx(DSSeparator, { dashed: true, orientation: "horizontal", position: "initial" }) }),
    /* @__PURE__ */ jsx(Grid, { span: 12, children: /* @__PURE__ */ jsx(
      DSAccordion,
      {
        activeValue: activeAccordions[index] ? index : null,
        onChange: () => handleAccordionToggle(index),
        children: [
          /* @__PURE__ */ jsx(
            DSAccordionItem,
            {
              title: activeAccordions[index] ? "Hide Detailed Entry" : "Open Detailed Entry",
              value: index,
              children: /* @__PURE__ */ jsx(Grid, { cols: ["repeat(12, 0.5fr)"], gutter: "xs", children: renderScreenFields(screen.id, "DETAILED") })
            },
            index
          )
        ]
      }
    ) })
  ] }, screen.id)) }) });
};
export {
  SchemaSearchForm
};
